module.exports = __webpack_public_path__ + "img/hr-sand-decal-07.05b64261.png";